import Axios from 'axios'
import { RequestOptions } from '@/interfaces/app/Client'
import config from '@/config'
import store from '@/store/'
import router from '@/router/'
import createMessage from '@/services/app/createMessage'
import { MessageType } from '@/interfaces/app/Message'

const client = Axios.create({
  baseURL: config.baseUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

client.interceptors.response.use(undefined, error => {
  if (401 === error.response.status && store.getters['user/isLoggedIn']) {
    const message = createMessage(
      'Platnost přihlášení vypršela',
      MessageType.Warning
    )
    store.commit('app/clearMessages')
    store.dispatch('user/logout').then(() => {
      store.dispatch('app/addTempMessage', { message, timeout: 3500 })
      router.push({ name: 'login' })
    })
  } else {
    return Promise.reject(error)
  }
})

export default async function(options: RequestOptions) {
  const { url, ...restOptions } = options
  const token = store.getters['user/token']
  if (token) {
    client.defaults.headers.common.Authorization = `Bearer ${token}`
  }

  const onSuccess = (response: any) => {
    return response.data
  }

  const onError = (error: any) => {
    return Promise.reject(error.response || error.message)
  }

  return client(url, restOptions)
    .then(onSuccess)
    .catch(onError)
}
